import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addDeed, updateDeed, deleteDeed } from "../services/api";
import { DEEDS_QUERY_KEY } from "./useDeeds";

const useInvalidateDeeds = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: DEEDS_QUERY_KEY });
    queryClient.invalidateQueries({ queryKey: ["deed-suggestions"] });
  };
};

export const useAddDeed = () => {
  const invalidate = useInvalidateDeeds();
  return useMutation({
    mutationFn: (deedJson) => addDeed(deedJson),
    onSuccess: invalidate,
  });
};

export const useUpdateDeed = () => {
  const invalidate = useInvalidateDeeds();
  return useMutation({
    mutationFn: ({ id, deedJson }) => updateDeed(id, deedJson),
    onSuccess: invalidate,
  });
};

export const useDeleteDeed = () => {
  const invalidate = useInvalidateDeeds();
  return useMutation({
    mutationFn: (id) => deleteDeed(id),
    onSuccess: invalidate,
  });
};

export { useInvalidateDeeds };
